import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject
} from '@angular/core';
import {
  Company,
  ProposalRequest,
  ProposalRequestFile,
  ProposalRequestVendor
} from 'src/app/classes/models';
import { LocalizationInfo } from 'src/app/interfaces/localization-info';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-quicksource-review',
  templateUrl: './quicksource-review.component.html',
  styleUrls: ['./quicksource-review.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class QuicksourceReviewComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private ToastService: ToastService,
    private SharedDataService: SharedDataService,
    private UtilityService: UtilityService
  ) {
    this.SharedDataService.listenForEvent<
      ProposalRequest | Company | boolean
    >().subscribe({
      next: ({ eventName, data }) => {
        if (
          eventName === 'SetProposalRequest' &&
          data instanceof ProposalRequest
        ) {
          this.ProposalRequest = data;
          this.setProposalRequestVendors();
          this._cdr.markForCheck();
        }

        if (eventName === 'SetCompany' && data instanceof Company) {
          this.Company = data;

          const { country } = this.Company;

          if (!country) {
            throw this.ToastService.addErrorToast(
              'Error',
              'Missing country information.',
              { returnError: true }
            );
          }

          this.LocalizationInfo =
            this.UtilityService.getLocalizedValuesMap(country);
          this._cdr.markForCheck();
        }
      }
    });

    this.SharedDataService.sendEvent('GetProposalRequest');
    this.SharedDataService.sendEvent('GetCompany');
  }

  ProposalRequest!: ProposalRequest;
  LocalizationInfo?: LocalizationInfo;
  Company!: Company;
  disableInput: boolean = false;

  ProposalRequestViveVendors: ProposalRequestVendor[] = [];
  ProposalRequestNonViveVendors: ProposalRequestVendor[] = [];

  displayEmails(emails: string) {
    return emails.split(/[;,]/);
  }

  setProposalRequestVendors() {
    const { ProposalRequestVendors } = this.ProposalRequest;

    if (!Array.isArray(ProposalRequestVendors)) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Proposal Vendors not loaded properly.',
        { returnError: true }
      );
    }

    ProposalRequestVendors.forEach((prv) => {
      const { VendorId } = prv;

      if (VendorId) {
        this.ProposalRequestViveVendors.push(prv);
      } else {
        this.ProposalRequestNonViveVendors.push(prv);
      }
    });
    this._cdr.markForCheck();
  }

  // Use ICal generator to create and download an ICal file using FileSaver.
  /*
  downloadICSFile(dateType: 'startDate' | 'dueDate' | 'reminderDate') {
    const dateValue = this.ProposalRequest[dateType];

    if (!dateValue) {
      throw this.ToastService.addErrorToast('Error', 'Date hasn\'t been set.', { returnError: true });
    }

    const LuxonDate = DateTime.fromJSDate(dateValue);

    const dateTypeToInformationMap: {
      startDate: {
        name: 'Proposal Start Date',
        description: string,
        summary: string
      },
      dueDate: {
        name: 'Proposal Due Date',
        description: string,
        summary: string
      },
      reminderDate: {
        name: 'Proposal Reminder Date',
        description: string,
        summary: string
      }
    } = {
      startDate: {
        name: 'Proposal Start Date',
        description: 'Proposal start date.',
        summary: 'Reminder for when the Proposal starts.'
      },
      dueDate: {
        name: 'Proposal Due Date',
        description: 'Proposal due date.',
        summary: 'Reminder for when the Proposal bids are due.'
      },
      reminderDate: {
        name: 'Proposal Reminder Date',
        description: 'Proposal reminder date.',
        summary: 'When an email will be sent as a reminder for the Proposal.'
      }
    }

    const ICalendar = ICal({
      name: `${dateType} ICalendar File`,
      method: ICalCalendarMethod.REQUEST,
      events: [
        {
          start: LuxonDate,
          description: dateTypeToInformationMap[dateType].description,
          summary: dateTypeToInformationMap[dateType].summary
        }
      ]
    });

    FileSaver.saveAs(new Blob([ICalendar.toString()]), `${dateTypeToInformationMap[dateType].name}.ics`);
  };
  */

  downloadProposalRequestFile(ProposalRequestFileRecord: ProposalRequestFile) {
    this.SharedDataService.sendEvent(
      'DownloadProposalRequestFile',
      new ProposalRequestFile(ProposalRequestFileRecord)
    );
  }

  ngOnInit(): void {}
}
